export const settings = {
	allChords: ['1', '2', '3', '4', '5', '6', '7'],
	userSelectedChords: () => this.allChords,  // change when implementing settings
	numOfChords: 4,
	allowRepeatChords: false
	// playbackSpeed: 1,
	// key: 'C',
	// instrument: 'piano',
}
